module.exports = __webpack_public_path__ + "img/SV.8c328f41.jpg";